import { SurveyScoreSummary } from "../../DTOs";

export class SurveyScoreStats
{
    public totalSelections:number;
    public selectionSum:number;
    public selectionAverage:number;
    public agreePlusPct:number;
    public disagreeMinusPct:number;

    constructor(
        public summary:SurveyScoreSummary
    )
    {
        this.totalSelections =
            summary.score1Count +
            summary.score2Count +
            summary.score3Count +
            summary.score4Count +
            summary.score5Count;

        this.selectionSum =
            summary.score1Count * 1 +
            summary.score2Count * 2 +
            summary.score3Count * 3 +
            summary.score4Count * 4 +
            summary.score5Count * 5;

        this.selectionAverage =
            this.totalSelections === 0
                ? 0
                : this.selectionSum / this.totalSelections;

        this.agreePlusPct =
            this.totalSelections === 0
                ? 0
                : (summary.score4Count + summary.score5Count) / this.totalSelections * 100;

        this.disagreeMinusPct =
            this.totalSelections === 0
                ? 0
                : (summary.score1Count + summary.score2Count) / this.totalSelections * 100;
    }

    static combine(statsList:SurveyScoreSummary[]):SurveyScoreStats
    {
        const combinedSummary:SurveyScoreSummary = {
            score1Count:0,
            score2Count:0,
            score3Count:0,
            score4Count:0,
            score5Count:0
        };

        for(const stats of statsList){
            combinedSummary.score1Count += stats.score1Count;
            combinedSummary.score2Count += stats.score2Count;
            combinedSummary.score3Count += stats.score3Count;
            combinedSummary.score4Count += stats.score4Count;
            combinedSummary.score5Count += stats.score5Count;
        }

        return new SurveyScoreStats(combinedSummary);
    }
}
